/**
 * Thème de l'interface : posé en `data-theme` sur <html>, lu par
 * packages/ui/src/tokens.css. Sombre par défaut (aucun attribut).
 * « system » suit le réglage du système et se met à jour s'il change.
 * « campus » : design system « Monde du campus » de Charles.
 */
export type ThemePreference = 'dark' | 'light' | 'system' | 'campus';

let systemQuery: MediaQueryList | null = null;
let systemListener: ((e: MediaQueryListEvent) => void) | null = null;

function setThemeAttribute(theme: 'dark' | 'light' | 'campus'): void {
  document.documentElement.dataset.theme = theme;
}

export function applyTheme(preference: ThemePreference): void {
  if (systemQuery && systemListener) {
    systemQuery.removeEventListener('change', systemListener);
    systemListener = null;
  }
  if (preference !== 'system') {
    setThemeAttribute(preference);
    return;
  }
  systemQuery ??= window.matchMedia('(prefers-color-scheme: light)');
  setThemeAttribute(systemQuery.matches ? 'light' : 'dark');
  systemListener = (e) => setThemeAttribute(e.matches ? 'light' : 'dark');
  systemQuery.addEventListener('change', systemListener);
}
